import * as React from 'react';
import { IRadioProps } from './IRadio';

const Radio = (props: IRadioProps) => {
    let id = `id_${props.title.replaceAll(' ', '_')}`;
    return (
        <div className='d-flex align-items-center'>
            <input type='radio' id={id} name={props.name} value={props.value} checked={props.checked} defaultChecked={props.defaultChecked} disabled={props.disabled} onChange={props.onChange} />
            <label htmlFor={id}>{props.title}</label>
        </div>
    );
};

export default Radio;
